import { render } from "./StandartTemplate.vue?vue&type=template&id=1796c285&ts=true"
import script from "./StandartTemplate.vue?vue&type=script&lang=ts"
export * from "./StandartTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__